import { Link } from "react-router-dom";
import { AnnouncementItem as Announcement } from "@/lib/webContentTypes";

const typeConfig = {
  urgente: { color: "border-red-500", bg: "bg-red-50", icon: "ri-alarm-warning-line", iconColor: "text-red-500", badge: "bg-red-100 text-red-700" },
  corte: { color: "border-orange-500", bg: "bg-orange-50", icon: "ri-drop-line", iconColor: "text-orange-500", badge: "bg-orange-100 text-orange-700" },
  informativo: { color: "border-sky-500", bg: "bg-sky-50", icon: "ri-information-line", iconColor: "text-sky-500", badge: "bg-sky-100 text-sky-700" },
  mantencion: { color: "border-amber-500", bg: "bg-amber-50", icon: "ri-tools-line", iconColor: "text-amber-500", badge: "bg-amber-100 text-amber-700" },
};

const typeLabel = {
  urgente: "Urgente",
  corte: "Corte de agua",
  informativo: "Informativo",
  mantencion: "Mantención",
};

interface Props {
  announcement: Announcement;
}

export default function AnnouncementBanner({ announcement }: Props) {
  const cfg = typeConfig[announcement.announcementType];
  return (
    <div className={`flex items-start gap-4 p-5 rounded-xl border-l-4 ${cfg.color} ${cfg.bg}`}>
      <div className={`w-9 h-9 flex items-center justify-center rounded-full bg-white flex-shrink-0 ${cfg.iconColor}`}>
        <i className={`${cfg.icon} text-lg`}></i>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${cfg.badge}`}>
            {typeLabel[announcement.announcementType]}
          </span>
          <span className="text-xs text-slate-400">
            {new Date(announcement.date).toLocaleDateString("es-CL", { day: "numeric", month: "long", year: "numeric" })}
          </span>
        </div>
        <h4 className="font-bold text-slate-800 text-sm md:text-base">{announcement.title}</h4>
        <p className="text-slate-600 text-sm mt-1 leading-relaxed">{announcement.summary || announcement.content}</p>
      </div>
      <Link
        to="/comunicados"
        className="flex-shrink-0 text-xs font-semibold text-sky-600 hover:text-sky-800 whitespace-nowrap cursor-pointer hidden sm:block"
      >
        Ver más <i className="ri-arrow-right-line"></i>
      </Link>
    </div>
  );
}
